import React from "react";
// See https://github.com/carbon-design-system/gatsby-theme-carbon/issues/860
import Switcher from "gatsby-theme-carbon/src/components/Switcher"; // default export, no brackets needed
import { SwitcherLink } from "gatsby-theme-carbon/src/components/Switcher"; // add brackets
import { SwitcherDivider } from "gatsby-theme-carbon/src/components/Switcher"; // add brackets

const CustomSwitcher = (props) => (
  <Switcher {...props}>
    <SwitcherDivider>Data Science</SwitcherDivider>
    <SwitcherLink href="https://data.billalive.com">
      {" "}
      {}
      Data Science Articles
    </SwitcherLink>
    <SwitcherLink href="https://vaccineshow.billalive.com">
      {" "}
      {}
      The Vaccine Show!
    </SwitcherLink>
    <SwitcherDivider>Coding and Web Development</SwitcherDivider>
    <SwitcherLink href="https://wineskinwebsites.com">
      {" "}
      {}
      Wineskin Websites
    </SwitcherLink>
    <SwitcherLink href="https://yarm.readthedocs.io/en/latest/">
      {" "}
      {}
      Yarm: Yet Another Report Maker
    </SwitcherLink>
    <SwitcherLink href="https://github.com/billalive/">
      {" "}
      {}
      Github @billalive
    </SwitcherLink>
    <SwitcherDivider>Nonfiction Writing</SwitcherDivider>
    <SwitcherLink href="https://yourawesomememory.com">
      {" "}
      {}
      Your Awesome Memory
    </SwitcherLink>
    <SwitcherLink href="https://yourwritingiskillingyou.com">
      {" "}
      {}
      Your Writing Is Killing You
    </SwitcherLink>
    <SwitcherLink href="https://notes.billalive.com">
      {" "}
      {}
      Notes: A "Digital Garden"
    </SwitcherLink>
    <SwitcherDivider>Fiction Writing</SwitcherDivider>
    <SwitcherLink href="https://billalive.com">
      {" "}
      {}
      Author Site for Bill Alive
    </SwitcherLink>
  </Switcher>
);

export default CustomSwitcher;
